import PatientFiles from "../components/PatientFiles/PatientFiles";

function Files(props) {
  return (
    <div className="col-12">
      <PatientFiles {...props} />
    </div>
  );
}

export default Files;
